import { useSelector } from 'react-redux';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import useLocation from '@src/hooks/useLocation';

/**
 * Whether this account may use Educators mode at all. Everything the mode adds
 * hangs off this, so with the flag off the app behaves exactly as it did before
 * the mode existed.
 *
 * The landing page asks the same flag to decide where its sign-in button lands,
 * and there the visitor is not signed in yet — ip is the only attribute both
 * sides can supply. So the rule has to be one ip alone can satisfy, and ip is
 * passed here too for the two answers to agree.
 */
const useEducatorsModeEnabled = () => {
  const { getFeatureValue } = useFeatureFlags();
  const user = useSelector((state) => state.auth.user);
  const { ip } = useLocation();

  return Boolean(
    getFeatureValue(FEATURE_KEYS.EDUCATORS_MODE, {
      ip,
      userId: user?.id,
      email: user?.email,
      phoneNumber: user?.phoneNumber,
    }),
  );
};

export default useEducatorsModeEnabled;
